module.exports = __webpack_public_path__ + "static/media/group-chat-blue-icon.41e7f079.svg";